export default __webpack_public_path__ + "static/OTO-logo-3d1c1667f18093c90a6dcea94291301b.svg";